import { PaginatedResponse, PaginationType, SearchParams } from "helpers";
import { api } from "services";
import { imageToFormData, postImage } from "services/images";

import { articleToBody, resToArticle } from "./transformations";
import { Article } from "./types";

export const getArticles = async (
  pagination: PaginationType,
  search: SearchParams
): Promise<PaginatedResponse<Article>> => {
  const params = [
    `pageNumber=${pagination.currentPage}`,
    `pageSize=${pagination.pageSize}`,
    `sortBy=${search.sortBy}`,
    `desending=${search.descending}`,
    `search=${search.search}`,
  ];
  const url = `/articles?${params.join("&")}`;
  const resp = await api.get(url);
  return { data: resp.data.data.map(resToArticle), meta: resp.data.meta };
};

export const getArticle = async (id: number): Promise<Article> => {
  const resp = await api.get(`/articles/${id}`);
  return resToArticle(resp.data);
};

export const putArticle = async (data: Article): Promise<Article> => {
  // Upload image
  if (data.image && data.image.buffer.byteLength) {
    const formData = imageToFormData(data.image);
    const newImage = await postImage(formData);
    data.image.id = newImage.id;
  }

  const body = articleToBody(data);
  const resp = await api.put(`/articles/${data.id}`, body);
  return resToArticle(resp.data);
};

export const postArticle = async (data: Article) => {
  // Upload image
  if (data.image && data.image.buffer.byteLength) {
    const formData = imageToFormData(data.image);
    const newImage = await postImage(formData);
    data.image.id = newImage.id;
  }

  const body = articleToBody(data);
  const resp = await api.post(`/articles`, body);
  return resToArticle(resp.data);
};

export const publishArticle = async (id: number, published: boolean) => {
  const resp = await api.put(`articles/${id}/publish`, { published });
  return resToArticle(resp.data);
};

export const deleteArticle = async (id: number): Promise<void> => {
  await api.delete(`/articles/${id}`);
};
